import React, { ReactChild, useState } from 'react'
import { ProfileModel } from '../../modules/profile/profileModel'
import { typeProspectEnum } from '../../modules/profile/enums/typeProspectEnum'

export const USER_INFOS_INITIAL: ProfileModel = {
	id: '',
	email: '',
	phone: '',
	type: typeProspectEnum.contact,
	language: '',
	hasAcceptedEmail: false,
	hasAcceptedSMS: false,
	ereleve: false
}

export const AppContext = React.createContext({
		userInfos: USER_INFOS_INITIAL,
		setUserInfos: (user: ProfileModel) => {
		}
	}
)

const AppProvider = (props: { children: ReactChild }) => {
	const [userInfos, setUserInfos] = useState<ProfileModel>(USER_INFOS_INITIAL)

	return (
		<AppContext.Provider
			value={{
				userInfos,
				setUserInfos
			}}
		>
			{props.children}
		</AppContext.Provider>
	)
}

export default AppProvider
